﻿(function () {
    "use strict";

    var app = angular.module("app");

    app.directive('convertToNumber', function () {
        return {
            require: 'ngModel',
            link: function (scope, element, attrs, ngModel) {
                ngModel.$parsers.push(function (val) {
                    val = val !== null ? parseFloat(val.toString().replace(/[^-\d\.]/g, ""), 10) : null;

                    return val;
                });
                ngModel.$formatters.push(function (val) {
                    return val !== null ? '' + val : null;
                });
            }
        };
    });

})();
